import React from "react";
import { connect, shallowEqual, useSelector } from "react-redux";
import * as categoryRedux from "modules/Category/_redux/categoryRedux";
import * as advertRedux from "modules/Advert/_redux/advertRedux";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import "./sahibindenFilters.css";

// Sahibinden tarzı çoklu seçim: dropdown yerine inline checkbox listesi.
// 8'den uzun listelerde (renk, motor-gucu) küçük bir arama kutusu açılır.
const MultiSelectSection = (props) => {
  const { selectedFilter } = useSelector(
    (state) => ({ selectedFilter: state.category.selectedFilter }),
    shallowEqual
  );

  const { slug, title } = props.filter;
  const values = props.filter.values || [];
  const selected = selectedFilter[slug] || [];

  const [query, setQuery] = React.useState("");
  const showSearch = values.length > 8;
  const visible = showSearch
    ? values.filter((v) =>
        String(v).toLocaleLowerCase("tr").includes(query.toLocaleLowerCase("tr"))
      )
    : values;

  const toggle = (value) => {
    const next = selected.includes(value)
      ? selected.filter((v) => v !== value)
      : [...selected, value];

    if (next.length === 0) {
      props.removeFilter({ parent: slug });
    } else {
      props.addFilterBulk({ parent: slug, value: next });
    }
  };

  return (
    <section id={props.filter.id} className="sf-section">
      <div className="sf-title">{title}</div>
      {showSearch && (
        <input
          className="sf-search"
          placeholder="Ara"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      )}
      <div className="sf-options">
        {visible.map((value) => (
          <FormControlLabel
            key={value}
            classes={{ label: "sf-option-label" }}
            control={
              <Checkbox
                size="small"
                color="primary"
                checked={selected.includes(value)}
                onChange={() => toggle(value)}
              />
            }
            label={value}
          />
        ))}
      </div>
    </section>
  );
};

export default connect(null, {
  ...categoryRedux.actions,
  ...advertRedux.actions,
})(MultiSelectSection);
